import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import CustomInput from '../components/CustomInput';
import { functionsBaseUrl } from '../config/runtime';


const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });
    const [showSuccess, setShowSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email.trim() || !formData.message.trim()) {
            alert("Please fill all required fields");
            return;
        }

        try {
            setSubmitting(true);

            const response = await fetch(
                `${functionsBaseUrl}/sendNewEmail`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        type: "contact_enquiry",
                        payload: formData,
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok || data.error) {
                console.error("SMTP2GO error:", data);
                throw new Error("Email failed");
            }

            // Show success card
            setShowSuccess(true);
        } catch (error) {
            console.error("Error sending contact email:", error);
            alert("Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    const clearAll = () => {
        setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
        });
        setShowSuccess(false);
    }


    return (
        <div className="bg-background min-h-full flex flex-col font-['Plus_Jakarta_Sans',sans-serif]">
            <NavBar />
            <section className="max-w-[1200px] mx-auto w-full px-[16px] md:px-[40px] py-[32px] md:py-[48px] flex flex-col gap-[24px]">
                <a className="inline-flex items-center gap-[6px] font-semibold text-[13px] text-[#717182] hover:text-[#212326] transition-colors no-underline self-start" href="/" data-discover="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left w-[14px] h-[14px]">
                        <path d="m12 19-7-7 7-7"></path>
                        <path d="M19 12H5"></path>
                    </svg>
                    Back to Home
                </a>
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-[32px] lg:gap-[48px]">


                    <div className="lg:col-span-2">
                        <h1 className="font-semibold text-[32px] md:text-[40px] text-[#212326] tracking-[-1px] mb-[12px]">
                            Get in touch
                        </h1>
                        <p className="font-medium text-[16px] text-[#717182] leading-[1.6] mb-[32px]">
                            Have a question about SignetPrint, need help with your listing, or want to discuss a partnership? We'd love to hear from you.
                        </p>
                        <div className="flex flex-col gap-[20px]">
                            <div className="flex items-start gap-[14px]">
                                <div className="w-[44px] h-[44px] rounded-[12px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        className="lucide lucide-mail w-[20px] h-[20px] text-[#ff5323]">
                                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7">
                                        </path>
                                    </svg>
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">Email</p>
                                    <a href="mailto:shiv@signetsolutions.co.za"
                                        className="font-medium text-[14px] text-[#ff5323] no-underline hover:underline"
                                    >
                                        shiv@signetsolutions.co.za
                                    </a>
                                </div></div><div className="flex items-start gap-[14px]">
                                <div className="w-[44px] h-[44px] rounded-[12px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        className="lucide lucide-phone w-[20px] h-[20px] text-[#ff5323]">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">Phone</p>
                                    <a href="tel:+27832511287"
                                        className="font-medium text-[14px] text-[#717182] no-underline hover:text-[#ff5323] transition-colors"
                                    >
                                        +27 (0) 83 251 1287
                                    </a>
                                </div>
                            </div>
                            {/* <div className="flex items-start gap-[14px]">

                                <div className="w-[44px] h-[44px] rounded-[12px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        className="lucide lucide-map-pin w-[20px] h-[20px] text-[#ff5323]">
                                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg>
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">Address</p>
                                    <p className="font-medium text-[14px] text-[#717182] leading-[1.5]">
                                        Watershed, 17 Dock Rd,<br></br>V&amp;A Waterfront, Cape Town, 8002
                                    </p>
                                </div>
                            </div> */}
                            <div className="flex items-start gap-[14px]">
                                <div className="w-[44px] h-[44px] rounded-[12px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        className="lucide lucide-clock w-[20px] h-[20px] text-[#ff5323]"
                                    >
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline points="12 6 12 12 16 14"></polyline>
                                    </svg>
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">Business Hours</p>
                                    <p className="font-medium text-[14px] text-[#717182]">Mon - Fri: 8:00 - 17:00</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* RIGHT SIDE - FORM */}

                    <div className="lg:col-span-3">
                        {showSuccess ? (

                            <div className="bg-white rounded-[20px] border border-[#e4e5e7] shadow-[0px_2px_28px_0px_rgba(0,0,0,0.05)] p-[40px] md:p-[56px] flex flex-col items-center text-center gap-[20px]">

                                <div className="w-[64px] h-[64px] rounded-full bg-[#e8f8e8] flex items-center justify-center">

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="w-[32px] h-[32px] text-[#2ecc71]"
                                    >
                                        <path d="M20 6 9 17l-5-5"></path>
                                    </svg>

                                </div>

                                <h2 className="font-semibold text-[24px] text-[#212326]">
                                    Message sent!
                                </h2>

                                <p className="font-medium text-[15px] text-[#717182] leading-[1.6] max-w-[380px]">
                                    Thanks for reaching out. We'll get back to you at{" "}
                                    <span className="font-semibold text-[#ff5323]">
                                        {formData.email}
                                    </span>{" "}
                                    as soon as possible.
                                </p>

                                <button
                                    type="button"
                                    onClick={clearAll}
                                    className="px-[24px] py-[12px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[15px] hover:bg-[#e64a1f] transition-colors mt-[4px]"
                                >
                                    Send Another Message
                                </button>

                            </div>

                        ) : (

                            <form className="bg-white rounded-[20px] border border-[#e4e5e7] shadow-[0px_2px_28px_0px_rgba(0,0,0,0.05)] p-[24px] md:p-[40px] flex flex-col gap-[20px]">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
                                    <CustomInput
                                        label="Name"
                                        placeholder="Your name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />

                                    <CustomInput
                                        label="Email Address"
                                        required
                                        type="email"
                                        placeholder="your@email.com"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <CustomInput
                                    label="Subject"
                                    placeholder="What's this about?"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                />

                                <div className="flex flex-col gap-[6px]">
                                    <label className="font-semibold text-[13px] text-[#212326]">
                                        Message <span className="text-[#ff5323]">*</span>
                                    </label>

                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Tell us how we can help..."
                                        rows={6}
                                        className="w-full rounded-[12px] border border-[#e4e5e7] px-[16px] py-[14px] font-medium text-[14px] text-[#212326] leading-[1.6] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors resize-none"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    onClick={handleContactSubmit}
                                    disabled={!formData.email?.trim() || !formData.message?.trim()}
                                    className={`flex items-center justify-center gap-[8px] w-full md:w-auto self-end px-[28px] py-[14px] rounded-[12px] font-semibold text-[15px] transition-all ${formData.email?.trim() && formData.message?.trim()
                                        ? "bg-[#ff5323] text-white hover:bg-[#e64a1f] shadow-[0px_2px_8px_rgba(255,83,35,0.3)]"
                                        : "bg-[#e4e5e7] text-[#9298a0] cursor-not-allowed"
                                        }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="w-[16px] h-[16px]"
                                    >
                                        <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                                        <path d="m21.854 2.147-10.94 10.939"></path>
                                    </svg>
                                    {submitting ? "Sending..." : "Send Message"}
                                </button>

                            </form>
                        )}
                    </div>


                </div>

            </section>
            <Footer />

        </div>

    );
};

export default Contact;
